export const SPECIES_LIST = [
  "Acacia", "Berlandier Acacia", "Blackbrush acacia", "Bullhorn acacia", "Sweet acacia", "Acacia greggii", "Chucum", "Achuchil",
  "Alder", "Arizona alder", "European black alder", "Hazel alder", "Mountain alder", "Mexican alder", "Red alder", "Seaside alder", "Sitka alder", "White alder",
  "Angelica-tree", "Japanese angelica-tree", "Devil's walking stick",
  "Apple", "Common apple", "Monkey-Puzzle", "Pacific crab apple", "Pond apple", "Siberian crab apple", "Wild crab apple",
  "Apricot",
  "Ash", "Black ash", "Blue ash", "California ash", "European ash", "Green ash", "Oregon ash", "Pumpkin ash", "Single-leaf ash", "Swamp ash", "White ash", "Mountain ash",
  "Aspen", "Bigtooth aspen", "Trembling aspen", "Quaking aspen",
  "Balsa",
  "Basswood", "American basswood", "Little-leaf linden", "White linden",
  "Bay", "Loblolly-bay", "Redbay", "Swampbay",
  "Beech", "American beech", "Blue-beech",
  "Birch", "Alaska birch", "Blueleaf birch", "Cherry birch", "European white birch", "Grey birch", "Kenai Birch", "Mountain paper birch", "Paper birch", "River birch", "Virginia round-leaf birch", "Water birch", "Yellow birch",
  "Blackbrush",
  "Bonete",
  "Breadnut",
  "Buck-wheat tree",
  "Buckeye", "California buckeye", "Mexican buckeye", "Ohio buckeye", "Red buckeye", "Yellow buckeye",
  "Buckthorn", "European buckthorn", "Glossy buckthorn", "Cascara buckthorn",
  "Bully", "Buckthorn bully", "Gum bully", "White bully", "False mastic",
  "Buttonbush",
  "Buttonwood",
  "Calabash", "Calabash tree", "Mexican calabash",
  "Caper", "Jamaican caper",
  "Catalpa", "Northern catalpa", "Southern catalpa",
  "Cedar", "Arizona cypress", "Atlas cedar", "Atlantic white cedar", "California incense-cedar", "Cedar-of-Lebanon", "Deodar cedar", "Eastern redcedar", "Eastern white cedar", "Eastern white-cedar", "Hinoki-Cypress", "Japanese-Cedar", "Lawson-Cypress", "Mexican white cedar", "Nootka cypress", "Oriental-cedar", "Sawara-Cypress", "Spanish cedar", "Texas cedar elm", "West Indian cedar", "Western red cedar", "Yellow-cedar",
  "Changungo",
  "Cherry", "Bitter cherry", "Black cherry", "Chokecherry", "Florida cherry palm", "Flowering Cherry", "Japanese flowering cherry", "Pin cherry", "Sour cherry", "Sweet cherry",
  "Chestnut", "American chestnut", "Chinese chestnut", "Malabar chestnut",
  "Chinquapin", "Allegheny chinquapin", "Dwarf chinquapin oak", "Ozark chinkapin",
  "Condalia", "Bitter condalia",
  "Copal",
  "Coral tree", "Flame coral tree",
  "Corkwood",
  "Corktree", "Amur corktree",
  "Cottonwood", "Black cottonwood", "Eastern cottonwood", "Frémont's cottonwood", "Narrowleaf cottonwood",
  "Cyrilla", "Swamp cyrilla",
  "Cypress", "Arizona smooth bark cypress", "Baker cypress", "Bald-Cypress", "Californian cypress", "Cuyamaca cypress", "Mendocino cypress", "Monterey cypress", "Paiute cypress", "Santa Cruz cypress", "Sargent's cypress", "Tecate cypress",
  "Divi-divi",
  "Dogwood", "Alternate-leaf dogwood", "Arnold dogwood", "Cornelian-Cherry", "Eastern flowering dogwood", "Kousa dogwood", "Northern swamp dogwood", "Roughleaf dogwood", "Silky dogwood", "Western flowering dogwood",
  "Douglas-fir", "Bigcone Douglas-fir",
  "Ebony", "Texas ebony",
  "Elder", "American elder", "Black-Cerry Elder", "Blue-berry Elder", "Eastern Red Elderberry", "Red-berry Elder",
  "Elm", "Common elm", "English elm", "Mexican elm", "Oregon myrtle", "Rock elm", "Scotch elm", "September elm", "Siberian elm", "Slippery elm", "Spanish elm", "West Indian elm", "White elm",
  "Euonymus", "Burning-bush euonymus", "European euonymus", "Winged euonymus", "Winter-creeper euonymus",
  "Fig", "Amate", "Florida strangler fig", "Shortleaf fig", "West Indian laurel fig",
  "Fir", "Balsam fir", "Bristlecone fir", "Grand fir", "Jalisco fir", "Nordmann Fir", "Noble fir", "Pacific silver fir", "Red fir", "Spanish Fir", "Subalpine fir", "White fir",
  "Frangipani",
  "Franklin tree",
  "Fringetree", "White fringetree",
  "Fiddlewood", "Florida fiddlewood",
  "Ginkgo",
  "Gliricidia",
  "Guaiacum", "Holywood", "Texas guaiacum",
  "Guava", "Brazilian guava", "Common guava",
  "Gumbo-limbo",
  "Hackberry", "Dwarf hackberry", "Netleaf hackberry", "Sugarberry",
  "Hawthorn", "Barberry hawthorn", "Bigfruit hawthorn", "Black hawthorn", "Cockspur hawthorn", "Columbia hawthorn", "Copenhagen hawthorn", "Dotted hawthorn", "Downy hawthorn", "Fanleaf hawthorn", "Fireberry hawthorn", "Fleshy hawthorn", "Fort Bend hawthorn", "Frosted hawthorn", "Grand Rapids hawthorn", "Green hawthorn", "Montgomery hawthorn", "One-flowered hawthorn", "Pear hawthorn", "Plumleaf hawthorn", "Scarlet hawthorn", "Valley Head hawthorn", "Washington hawthorn",
  "Hazel", "American hazel", "Beaked hazel", "European filbert", "Turkish hazel",
  "Hemlock", "Carolina hemlock", "Eastern hemlock", "Mountain hemlock", "Western hemlock",
  "Hickory", "Bitternut hickory", "Mockernut hickory", "Nutmeg hickory", "Red hickory", "Scrub hickory", "Shagbark hickory", "Shellbark hickory",
  "Holly", "Dahoon holly", "English holly", "Mountain winterberry", "Smooth winterberry", "Swamp holly", "American holly", "Common winterberry", "Yaupon holly",
  "Hopbush",
  "Hoptree", "California hoptree", "Common hoptree",
  "Hornbeam", "Hornbeam (Ironwood)",
  "Horse Chestnut",
  "Ironwood", "Black ironwood", "Catalina ironwood", "Desert ironwood", "Ironwood (Hornbeam)",
  "Jacaranda",
  "Jocote",
  "Joshua tree",
  "Juniper", "Alligator juniper", "Ashe juniper", "California juniper", "Chinese juniper", "Common juniper", "Creeping juniper", "Drooping juniper", "One-seed juniper", "Redberry juniper", "Rocky Mountain juniper", "Savin juniper", "Sierra juniper", "Utah juniper", "Western juniper",
  "Kapok",
  "Katsura", "Weeping Katsura",
  "Kidneywood", "Texas kidneywood",
  "Larch", "Dahurian larch", "European larch", "Japanese larch", "Siberian Larch", "Subalpine larch", "Tamarack", "Western larch",
  "Laurel", "Mountain laurel",
  "Leadtree", "White leadtree",
  "Lilac", "Common lilac",
  "Lime", "Wild lime",
  "Linden",
  "Locust", "Black locust", "Clammy locust", "Honey-locust", "Rose locust", "Water locust",
  "Lotebush",
  "Magnolia", "Bigleaf magnolia", "Cloudforest magnolia", "Cucumber tree", "Fraser magnolia", "Honduran magnolia", "Saucer magnolia", "Southern magnolia", "Umbrella magnolia",
  "Mahogany", "American mahogany", "Pacific Coast mahogany",
  "Majaguillo",
  "Maleberry",
  "Maple", "Amur maple", "Big-leaf maple", "Bigtooth maple", "Black maple", "Douglas maple", "Florida maple", "Japanese maple", "Manitoba maple", "Mountain maple", "Norway Maple", "Red maple", "Rocky Mountain maple", "Silver maple", "Striped maple", "Sugar maple", "Sycamore maple", "Vine maple", "Whitebark maple",
  "Medlar", "Stern's medlar",
  "Mesquite", "Screwbean mesquite", "Smooth mesquite", "Velvet mesquite",
  "Mombin", "Yellow mombin",
  "Monkeypod",
  "Mountain-ash", "American mountain-ash", "European mountain-ash", "Showy mountain-ash", "Sitka mountain-ash",
  "Mountain-Holly",
  "Mulberry", "Red mulberry", "White mulberry",
  "Myrtle",
  "Nectarine",
  "Nutmeg", "Florida nutmeg",
  "Oak", "Arizona blue oak", "Arizona white oak", "Arkansas oak", "Bear oak", "Black oak", "Blackjack oak", "Boynton oak", "Bur oak", "Canyon live oak", "Chapman oak", "Chestnut oak", "Chinquapin oak", "Chihuahua oak", "Durand oak", "Emory oak", "Encina", "Encino amarillo", "English oak", "Garry oak", "Georgia oak", "Gray oak", "Island oak", "Lacey oak", "Mexican oak", "Mexican white oak", "Mohr oak", "Myrtle oak", "Netleaf oak", "Northern pin oak", "Nuttall's oak", "Oglethorpe oak", "Overcup oak", "Palmer oak", "Pin oak", "Red oak", "Sandpaper oak", "Sand live oak", "Scarlet oak", "Shallow-lobed oak", "Shinnery oak", "Shumard Oak", "Silverleaf oak", "Southern live oak", "Swamp chestnut oak", "Swamp laurel oak", "Swamp white oak", "Texas red oak", "Turkey oak", "Turbinella oak", "Valley oak", "Vasey oak", "Water oak", "White Oak", "Willow oak", "Xalapa oak",
  "Old fustic",
  "Olive", "Texas wild olive",
  "Osage orange",
  "Oysterwood", "Shiny oysterwood",
  "Palm", "California fan palm", "Cuban royal palm", "Desert fan palm", "Florida silver palm", "Key thatch palm", "Mexican blue palm", "Mexican silver palm", "Paurotis palm", "Spiny palm", "Date palm",
  "Palo prieto",
  "Palo santo",
  "Palo verde", "Blue palo verde", "Texas palo verde", "Yellow paloverde",
  "Papelío",
  "Paradise-tree",
  "Pawpaw", "Papaw", "Smallflower pawpaw",
  "Pear",
  "Peach",
  "Pecan", "Bitter pecan",
  "Persimmon", "American persimmon", "Black sapote", "Texas persimmon",
  "Physic nut",
  "Pigeon plum",
  "Pine", "Apache pine", "Arizona pine", "Austrian pine", "Bristlecone pine", "Chihuahua pine", "Colorado pinyon", "Coulter pine", "Eastern White Pine", "Foxtail pine", "Great Basin bristlecone pine", "Gregg's pine", "Gray pine", "Jack pine", "Jeffrey pine", "Johann's pine", "Knobcone pine", "Limber Pine", "Loblolly pine", "Lodgepole pine", "Lumholtz's pine", "Mexican white pine", "Monterey pine", "Mugho Pine", "Parry pinyon", "Pinyon pine", "Pitch pine", "Pond pine", "Ponderosa pine", "Red pine", "Sand pine", "Scots Pine", "Shortleaf pine", "Single-leaf pinyon", "Smooth-bark Mexican pine", "Spruce pine", "Sugar pine", "Table Mountain pine", "Texas pinyon", "Torrey pine", "Weeping pinyon", "Western White Pine", "Whitebark Pine",
  "Pink shower tree",
  "Plane-tree", "London plane-tree",
  "Plum", "American plum", "Beach plum", "Canadian plum", "Mexican plum", "Saffron plum",
  "Poisonwood", "Florida poisonwood",
  "Poison-sumac",
  "Poplar", "Balsam poplar", "Carolina poplar", "Downy poplar", "European white poplar", "Lombardy poplar", "Simon poplar",
  "Potato Tree",
  "Poui", "Pink poui",
  "Prickly-ash", "Common prickly-ash", "Southern prickly ash",
  "Redbud", "Eastern redbud",
  "Redwood", "Coast redwood", "Dawn redwood", "Sierra redwood",
  "Rosewood", "Arizona rosewood",
  "Royal palm",
  "Russian-olive",
  "Sandalwood", "Yellow sandalwood",
  "Sandpaper tree",
  "Sapota", "Mamey sapote",
  "Sassafras",
  "Sea torchwood",
  "Sea-buckthorn",
  "Serviceberry", "Canadian serviceberry", "Downy serviceberry", "Mountain serviceberry", "Pacific serviceberry", "Roundleaf serviceberry", "Saskatoon berry", "Smooth serviceberry",
  "Shaving brush tree",
  "Silverbell", "Common silverbell", "Mountain silverbell", "Two-wing silverbell",
  "Smokethorn",
  "Soapberry", "Florida soapberry", "Wingleaf soapberry",
  "Soldierwood",
  "Soncoya",
  "Spruce", "Black spruce", "Brewer spruce", "Colorado spruce", "Engelmann spruce", "Norway spruce", "Red spruce", "Serbian spruce", "Sitka spruce", "White Spruce",
  "Sumac", "Evergreen sumac", "Littleleaf sumac", "Prairie sumac", "Shining sumac", "Smooth sumac", "Staghorn sumac", "Sugar sumac",
  "Sweetgum",
  "Sweetleaf", "Common sweetleaf",
  "Sycamore", "American sycamore", "Arizona sycamore", "California sycamore",
  "Tamarind", "False tamarind",
  "Tanoak",
  "Texas mountain laurel",
  "Texas plume",
  "Thatch palm",
  "Torreya", "California torreya",
  "Tree of heaven",
  "Trumpet tree", "Pink trumpet tree",
  "Tulip tree",
  "Tupelo", "Black tupelo", "Swamp tupelo", "Water tupelo", "White tupelo",
  "Twinberry",
  "Umbrella-Pine",
  "Viburnum", "Blackhaw", "Cranberry viburnum", "European Cranberry Viburnum", "Squashberry viburnum", "Sweet viburnum", "Wayfaring viburnum",
  "Walnut", "Arizona walnut", "Black walnut", "Butternut", "California black walnut", "Northern California walnut", "Texas walnut",
  "Willow", "Balsam willow", "Basket willow", "Bebb's willow", "Black willow", "Bonpland willow", "Crack willow", "Desert willow", "Florida willow", "Golden weeping willow", "Hooker willow", "Humboldt's willow", "Laurel willow", "Littletree Willow", "Pacific willow", "Peachleaf willow", "Purple-osier willow", "Pussy willow", "Red willow", "Sandbar willow", "Satiny willow", "Silky willow", "Violet willow", "Yew-leaf willow",
  "Witch-hazel",
  "Yellowwood", "Kentucky yellowwood", "Yellow-wood",
  "Yew", "Canada yew", "Eastern yew", "English yew", "Florida yew", "Japanese yew", "Western yew",
  "Zelkova", "Japanese zelkova",
  "Deciduous (Generic)", "Evergreen (Generic)", "Ornamental (Generic)"
];
